import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import './App.css';

  export default function SkeletonPage() {
    return (
        <>
            <Skeleton animation="wave" variant="rect" width={"100vw"} height={"60vh"} className={"skeleton"} />
            <Skeleton animation="wave" variant="text" width={"50vw"} height={"10vh"} className={"skeletonHeading"} />
            <Skeleton animation="wave" variant="rect" width={"96vw"} height={"32vh"} className={"skeletonCard"} />
        </>
    );
}